import { httpCreate } from './http';

const http = httpCreate('/api/user/weChat/unBinding');

export const wx = {
	unBound() {
		return http.post();
	},
};
